<template>
  <div>
    <span v-if="exibirHorarioDaPartida">
      <label for="horarioDaPartida" class="required">Horário Partida:</label>
      <input type="time" id="horarioDaPartida" v-model="passageiroEditado.horarioDaPartida" />
    </span>

    <br />
    <label for="passageiro" class="required">Nome:</label>
    <input v-model="passageiroEditado.nome" type="text" id="passageiro" placeholder="" class="estilo60" />

    <br />
    <label for="telefone" class="required">Telefone:</label>
    <input v-model="passageiroEditado.telefone" type="text" id="telefone" placeholder="" />

    <br />
    <Vinculo @vinculo-selecionado="receberEmitVinculo" v-model:vinculo="this.passageiroEditado.vinculo" />

    <label for="raRgReMatricula" class="required">RA/RG/RE/Matrícula:</label>
    <input v-model="passageiroEditado.raRgReMatricula" type="text" id="raRgReMatricula" placeholder="" />

    <br />
    <label for="email" class="required">E-mail:</label>
    <input v-model="passageiroEditado.email" type="text" id="email" placeholder="" class="estilo60" />

    <br />
    <label for="local-apresentacao" class="required">Local de apresentação:</label>
    <input v-model="passageiroEditado.localApresentacao" type="text" id="local-apresentacao" placeholder=""
      class="estilo60" />

    <Endereco @endereco-informado="receberEmitEndereco" v-model:endereco="this.passageiroEditado.endereco"
      :apenasLeitura="enderecoApenasLeitura" ref="enderecoComponent" />

    <br />
    <button @click="emitirPassageiro">Adicionar</button>
    <br /><br />
  </div>
</template>
  
<script>

import Vinculo from '@/components/Vinculo.vue';
import Endereco from '@/components/Endereco.vue';

export default {
  name: 'passageiro',
  emits: ['passageiro-informado'],
  props: {
    passageiro: Object,
    endereco: Object,
    enderecoApenasLeitura: Boolean,
    exibirHorarioDaPartida: Boolean
  },

  components: {
    Vinculo,
    Endereco
  },

  data() {
    return {
      passageiroEditado: { ...this.passageiro, endereco: this.endereco }

    };
  },

  methods: {

    receberEmitVinculo(v) {
      this.passageiroEditado.vinculo = v;
    },

    receberEmitEndereco(e) {
      this.passageiroEditado.endereco = e;
    },

    emitirPassageiro() {
      this.$emit('passageiro-informado', this.passageiroEditado);
    },

    resetForm() {
      this.passageiroEditado = {
        horarioDaPartida: '',
        nome: '',
        telefone: '',
        email: '',
        vinculo: '',
        raRgReMatricula: '',
        localApresentacao: ''
      };
    }
  },

  mounted() {
    // IMPORTANTE: Inicializar passageiroEditado com os dados do prop passageiro
    this.passageiroEditado = { ...this.passageiro };

    // Inicializa passageiroEditado.endereco com todas as chaves e valores null
    // Importante para forçar a existencia de todos os campos
    var enderecoDefault = {
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      bairro: null,
      cidade: null,
      pontoReferencia: null,
      estado: null
    };

    this.passageiroEditado.endereco = { ...enderecoDefault };
  },

  watch: {
    passageiro: {
      handler(newValue) {
        this.passageiroEditado = { ...newValue };
      },
      deep: true // IMPORTANTE: vê mudanças nas propriedades
    },

    endereco: {
      handler(newValue) {
        this.passageiroEditado.endereco = { ...newValue };
      },
      deep: true // IMPORTANTE: vê mudanças nas propriedades
    }

  },
};

</script>
  
<style src="../css/transporte.css"></style>